import _ from 'lodash';

export const getGlobalConfig = (headerService = {}, commonInitData = {}) => {
    const accountInfo = _.get(headerService, 'account._info', {});
    const hackCommonInitData = {
        globalConfig: {
            userInfo: {
                encryptId: accountInfo.encrypted_account_id,
                isSpecialIp: accountInfo.special_ip,
                email: accountInfo.email
            },
            companyInfo: {
                name: accountInfo.company_name,
                encryptId: accountInfo.encrypted_company_id
            },
            whiteLabel: {
                highLevel: headerService.whiteLabel && headerService.isHighLevelWhiteLabel,
                lowLevel: headerService.whiteLabel && !headerService.isHighLevelWhiteLabel
            }
        }
    };
    return _.merge(hackCommonInitData, commonInitData);
};
